import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import TextNavTitle from '../../components/TextNavTitle'

function index() {
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Training</TextNavTitle>
      </NavTitle>

      <Col xl={12}>
        <Card border="0" className="h-full">
          <Card.Body></Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default index
